import React from "react";
import "./MoreinfoArtistOppurtunity.css";

function MoreinfoArtistOppurtunity() {
  return (
    <div style={{ backgroundColor: "red" }}>MoreinfoArtistOppurtunity</div>
  );
}

export default MoreinfoArtistOppurtunity;
